import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { translate } from 'translations/translator';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import ModalsTranslationVariant from 'translations/variants/modals';
import { ModalPadding } from 'styles/style-constants';
type Props = {
  teachingOrderTitle: string | undefined;
  teachingOrderDescription?: string | undefined;
  handleDeleteTeachingOrder: () => void;
};

const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

export const DeleteTeachingOrderModal: React.FC<Props> = ({
  teachingOrderTitle,
  teachingOrderDescription,
  handleDeleteTeachingOrder
}) => {
  const classes = useStyles();
  const [, { closeModal }] = useModal();
  const withCloseModal = cb => () => {
    cb();
    closeModal();
  };
  return (
    <Container className={classes.container}>
      <Typography className={classes.title} variant="h6">
        {getTranslation(ModalsTranslationVariant.deleteTeachingOrderAreYouSure)}
      </Typography>
      <Box display="flex" flexDirection="column" className={classes.boxContainer}>
        <Typography variant="body2" style={{ padding: 16 }}>
          {teachingOrderTitle}
        </Typography>
        <Typography variant="body2" style={{ padding: '0 16px', fontWeight: 300 }}>
          {teachingOrderDescription}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography variant="body2" style={{ fontWeight: 300, padding: '12px 9px 0px 9px' }}>
          {getTranslation(ModalsTranslationVariant.deleteTeachingOrderDescription)}
        </Typography>
      </Box>
      <Box display="flex" className={classes.btnActionGroup}>
        <HwtButton onClick={closeModal} className={classes.button} variant="outlined">
          {getTranslation(ModalsTranslationVariant.teachingOrderBackToManage)}
        </HwtButton>
        <HwtButton
          onClick={withCloseModal(handleDeleteTeachingOrder)}
          className={classes.button2}
          variant="contained"
        >
          {getTranslation(ModalsTranslationVariant.yesDeleteTeachingOrder)}
        </HwtButton>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles((theme: any) => ({
  button: {
    width: 'max-content !important'
  },
  button2: {
    width: 'max-content !important',
    backgroundColor: '#D12348'
  },
  boxContainer: () => ({
    width: '568px',
    backgroundColor: theme.palette.grey.lightest
  }),
  container: {
    display: 'flex !important',
    justifyContent: 'space-evenly',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    height: '322px',
    width: '616px',
    backgroundColor: '#fff',
    ...ModalPadding
  },
  title: {
    display: 'flex',
    flex: '.05',
    padding: '18px 6px',
    alignSelf: 'center'
  },
  btnActionGroup: {
    marginTop: '24px',
    justifyContent: 'space-between'
  }
}));

export const useTeachingOrderStyles = useStyles;
